import Vue from "vue";

// vee-validate
import {
  ValidationObserver,
  ValidationProvider,
  Field,
  extend,
  configure,
} from "vee-validate";
import isURL from "validator/lib/isURL";
import * as rules from "vee-validate/dist/rules";
import i18n from "@/libs/i18n";

configure({
  // this will be used to generate messages.
  defaultMessage: (field, values) => {
    values._field_ = i18n.t(`${field}`);
    return i18n.t(`validations.messages.${values._rule_}`, values);
  },
});

// install rules
Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    // message: messages[rule] // assign message
  });
});

extend("decimal", {
  validate: (value, ref, { decimals = "*", separator = "." } = {}) => {
    if (value === null || value === undefined || value === "") {
      return {
        valid: false,
      };
    }
    if (ref === void 0) ref = [];
    var decimals = ref[0];
    if (decimals === void 0) decimals = "*";

    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value),
      };
    }
    const regexPart = decimals === "*" ? "+" : `{1,${decimals}}`;
    const regex = new RegExp(
      `^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`
    );

    return {
      valid: regex.test(value),
    };
  },
  message: function (field, ref) {
    if (ref === void 0) ref = [];
    var decimals = ref[0];
    if (decimals === void 0) decimals = "*";

    return i18n.t(`validations.messages.decimal`, {
      _field_: field,
      decimals: !decimals || decimals === "*" ? "" : decimals,
    });
  },
});

extend("url", {
  validate(value) {
    if (value) {
      return isURL(value, { require_tld: true });
    }

    return false;
  },
  message: function (field) {
    return i18n.t(`validations.messages.url`, {
      _field_: i18n.t(field),
    });
  },
});

//not validate url extension
extend("url_custom_extension", {
  validate(value) {
    const pattern = /^(https?:\/\/)([\w-]+\.)*[\w-]+(:\d+)?(\/[^\s]*)?$/i;
    return pattern.test(value);
  },
  message: function (field) {
    return i18n.t(`validations.messages.url`, {
      _field_: i18n.t(field),
    });
  },
});


extend("agree_policy", {
  validate: (value) => {
    return value;
  },
  message: function (field, ref) {
    return i18n.t(`validations.messages.agreePolicy`);
  },
});

extend("company_email", {
  validate: (value) => {
    var mail = value.split("@");
    var domain = mail[mail.length - 1];
    if (domain) {
      domain = domain.substring(0, domain.indexOf("."));
      var blacklist_domains = ["gmail", "yahoo", "outlook"];
      if (!blacklist_domains.includes(domain)) {
        return true;
      }
    }
    return false;
  },
  message: function (field, ref) {
    return i18n.t(`validations.messages.company_email`, {
      _field_: i18n.tc(field),
    });
  },
});

  // Add custom validation rule for min/max price comparison
extend('minMaxPrice', {
  params: ['min'],
  validate(value, { min }) {
    if (!min || !value) return true;
    return Number(value) > Number(min);
  },
  message: i18n.t('validations.messages.minMaxPrice')
});

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
